import { useState } from "react";
import type { Strings } from "../i18n/strings";
import type { Lang } from "../lib/types";
import { sendReport, type ReportBranch, type ReportReason } from "../lib/report";

interface Props {
  t: Strings;
  lang: Lang;
  branch: ReportBranch;
  inputText: string;
  responseText: string;
  onClose: () => void;
}

const REASONS: { id: ReportReason; key: keyof Strings }[] = [
  { id: "weird", key: "reasonWeird" },
  { id: "offensive", key: "reasonOffensive" },
  { id: "crisis_false_positive", key: "reasonCrisisFP" },
  { id: "other", key: "reasonOther" },
];

// 응답 신고 모달(AI 출력 플래그). 사유 택1 → 전송(명시적 옵트인). 실패 시 평문 에러+재시도.
export default function ReportModal({ t, lang, branch, inputText, responseText, onClose }: Props) {
  const [reason, setReason] = useState<ReportReason | null>(null);
  const [comment, setComment] = useState("");
  const [state, setState] = useState<"idle" | "sending" | "sent" | "error">("idle");

  async function submit() {
    if (!reason || state === "sending") return;
    setState("sending");
    const ok = await sendReport({
      reason,
      comment: comment.trim() || undefined,
      inputText,
      responseText,
      branch,
      locale: lang,
    });
    if (ok) {
      setState("sent");
      setTimeout(onClose, 1300);
    } else {
      setState("error");
    }
  }

  return (
    <div className="report-overlay" onClick={onClose}>
      <div className="report-modal" onClick={(e) => e.stopPropagation()}>
        {state === "sent" ? (
          <div className="report-sent">{t.reportSent}</div>
        ) : (
          <>
            <div className="report-title">{t.reportTitle}</div>
            <div className="report-reasons">
              {REASONS.map((r) => (
                <button
                  key={r.id}
                  className={`report-reason ${reason === r.id ? "on" : ""}`}
                  onClick={() => setReason(r.id)}
                >
                  {t[r.key]}
                </button>
              ))}
            </div>
            <textarea
              className="report-comment"
              value={comment}
              placeholder={t.reportCommentPh}
              maxLength={500}
              onChange={(e) => setComment(e.target.value)}
            />
            <div className="report-notice">{t.reportNotice}</div>
            {state === "error" && <div className="report-error">{t.reportFail}</div>}
            <div className="report-actions">
              <button className="report-cancel" onClick={onClose}>
                {t.close}
              </button>
              <button className="report-submit" disabled={!reason || state === "sending"} onClick={submit}>
                {state === "sending" ? <span className="btn-spin" /> : state === "error" ? t.retry : t.reportSend}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
